
import ProjectItem from "../components/ProjectItem";
import "../styles/Projects.css"
import { ProjectList } from "../helpers/ProjectList";
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";

function Projects() {
    const { language } = useLanguage();
    const t = translations[language].projects;

    return (
        <div className="projects">
            <h1 className="project-title">{t.title}</h1>
            <p className="project-subtitle">{t.subtitle}</p>
            <div className="project-list">
                {ProjectList.map((project, idx) => {
                    return <ProjectItem id={project.slug} name={project.name} image={project.image} bgOffsetY={project.bgOffsetY} inDevelopment={project.inDevelopment} />
                })}
            </div>
        </div>
    )
}

export default Projects